module.exports = __webpack_public_path__ + "images/emoji/speech_balloon.6a0c0804c491df2b50f2.png";